import api from './api';

/**
 * Student Activity Service - Handles all student activity & draft API calls
 */

export const saveActivity = async (activityData) => {
  try {
    const response = await api.post('/auth/student/save-activity/', activityData);
    return response.data;
  } catch (error) {
    console.error('Error saving activity:', error);
    throw new Error(error.response?.data?.error || error.message || 'Failed to save activity');
  }
};

export const fetchStudentActivities = async (params = {}) => {
  try {
    const response = await api.get('/auth/student/activities/', { params });
    const data = response.data;
    const items = Array.isArray(data?.results) ? data.results : (Array.isArray(data) ? data : []);
    const count = typeof data?.count === 'number' ? data.count : (data?.total_count || items.length);
    return {
      activities: items,
      total_count: count,
    };
  } catch (error) {
    console.error('Error fetching student activities:', error);
    return { activities: [], total_count: 0 };
  }
};

export const deleteActivity = async (id) => {
  try {
    const response = await api.delete(`/auth/student/delete-activity/${id}/`);
    return response.data;
  } catch (error) {
    console.error('Error deleting activity:', error);
    throw error;
  }
};

export const saveDraft = async (draftData) => {
  try {
    const response = await api.post('/auth/student/drafts/auto-save/', draftData);
    return response.data;
  } catch (error) {
    console.error('Error auto-saving draft:', error);
    throw error;
  }
};

export const fetchDrafts = async () => {
  try {
    const response = await api.get('/auth/student/drafts/');
    return response.data?.drafts || [];
  } catch (error) {
    console.error('Error fetching drafts:', error);
    return [];
  }
};

export const deleteDraft = async (id) => {
  try {
    const response = await api.delete(`/auth/student/drafts/${id}/`);
    return response.data;
  } catch (error) {
    console.error('Error deleting draft:', error);
    throw error;
  }
};

export const studentActivityAPI = {
  saveActivity,
  fetchStudentActivities,
  deleteActivity,
  saveDraft,
  fetchDrafts,
  deleteDraft,
};

export default studentActivityAPI;


export const fetchActivities = async (page = 1, filters = {}) => {
  return fetchStudentActivities({ page, ...filters });
};

export const fetchAllActivitiesForPDF = async (filters = {}) => {
  const filterParams = typeof filters === "object" ? filters : {};
  return fetchStudentActivities({ page: 1, page_size: 99999, ...filterParams });
};
